import { NUMERIC_CONFIG } from '@/shared/config';
import { getLimitPeriodRange } from './getLimitPeriodRange';
import type { LimitType } from '@/shared/types';
import type { LimitsResponseDto, TransformedLimitsData } from '../model';
import type { Locale } from 'date-fns';

export const buildTransformedLimitsData = (
  limitsData: LimitsResponseDto | undefined,
  limitTypes: LimitType[] | undefined,
  locale: Locale
): TransformedLimitsData | null => {
  if (!limitsData || !limitTypes || !locale) {
    return null;
  }

  const {
    baseCode,
    basePrecission = NUMERIC_CONFIG.precision.default,
    limits,
  } = limitsData;

  const currentPeriod = limits[0];

  if (!currentPeriod || currentPeriod.values.length === 0) {
    return null;
  }

  const periodRange = getLimitPeriodRange(currentPeriod.period, locale);

  const limitsMapped = limitTypes.map(limitType => {
    const value = currentPeriod.values.find(
      v => v.limitType === limitType.code
    );

    const used = value?.usedLimitAmount ?? 0;
    const limit = value?.setLimitAmount ?? 0;
    const left = Math.max(limit - used, 0);

    return {
      code: limitType.code,
      name: limitType.name,
      icon: limitType.icon,
      used,
      limit,
      left,
    };
  });

  return {
    periodRange,
    basePrecission,
    baseAsset: baseCode,
    limits: limitsMapped,
  };
};
